// 통신판매중개자 고지 — 전자상거래법 제20조: 당사자 아님을 고지해야 면책 주장 가능 (약관 v5.0 제4조의6)
// 중개 관련 화면(디자인외주·매칭·수수료)에 공통 배치.
import React from 'react';

function BrokerNotice({ style }) {
    return (
        <p style={{ fontSize: 12, color: '#94A3B8', lineHeight: 1.6, margin: '12px 0 0', ...style }}>
            ⓘ 덴탈클러스터는 통신판매중개자로서 회원 간 거래를 위한 시스템을 제공할 뿐 거래의 당사자가 아니며,
            재화·용역의 품질과 대금 정산에 대한 책임은 거래 당사자에게 있습니다. (이용약관 제4조의6)
            2026-08-17부로 중개 수수료가 전면 폐지되었습니다. 과거 청구 내역은 기록 열람용으로만 표시됩니다. (약관 v6.0 제4조의5)
        </p>
    );
}

export default BrokerNotice;
